import React from 'react';
import PropTypes from 'prop-types';
import { Typo } from '@ers/ui';
import BaseAvatar from './BaseAvatar';
import Types from './AvatarTypes';


const CompanyAvatar = ({ children }) => (
    <BaseAvatar type={Types.Company} text={children} contentBasedBG>
        {(initials) => (<Typo.Avatar.Company>{initials}</Typo.Avatar.Company>)}
    </BaseAvatar>
);

CompanyAvatar.propTypes = {
    children: PropTypes.node.isRequired,
};

export default CompanyAvatar;
